import { useMemo } from "react"
import moment from "moment"

/**
 * Calculates start and end dates for a calendar view based on params.
 * @param {Object} params - Calendar filter params (must include date, range)
 * @returns {{start: string, end: string}} - Start and end ISO date strings
 */
export function useCalendarDateRange(params) {
  return useMemo(() => {
    if (!params.date || !params.range) return {}
  const date = moment(params.date)
    const dates = {}

    if (params.range === "month") {
      dates.start = date.clone().startOf("month").startOf("week").format("YYYY-MM-DD")
      dates.end = date.clone().endOf("month").endOf("week").format("YYYY-MM-DD")
    } else if (params.range === "week") {
      dates.start = date.clone().startOf("week").format("YYYY-MM-DD")
      dates.end = date.clone().endOf("week").format("YYYY-MM-DD")
    } else {
      dates.start = date.clone().startOf("day").format("YYYY-MM-DD")
      dates.end = date.clone().endOf("day").format("YYYY-MM-DD")
    }

    return dates
  }, [params.date, params.range])
}
